<template>
    <div class="rounded-img overflow-hidden">
        <BlockedIframeWrapper>
            <iframe
                :[cookieAttributeName]="url"
                data-cookieconsent="marketing"
                class="w-full h-full"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
            />
        </BlockedIframeWrapper>
    </div>
</template>

<script>
import BlockedIframeWrapper from '@/Components/ModelComponents/Resources/BlockedIframeWrapper.vue'

export default {
    name: 'YoutubeEmbed',

    components: {
        BlockedIframeWrapper,
    },

    props: {
        url: {
            type: String,
            required: true,
        },
    },

    computed: {
        usingCookiebot() {
            return !!import.meta.env.VITE_COOKIEBOT_UUID
        },

        cookieAttributeName() {
            return this.usingCookiebot ? 'data-cookieblock-src' : 'src'
        },
    },
}
</script>
